export default function InputLabel({ htmlFor, value }) {
    return (
      <label htmlFor={htmlFor} className="block text-sm font-medium text-gray-700">
        {value}
      </label>
    );
  }
  